import React from 'react';
import WeeklyAvailabilityManager from './WeeklyAvailabilityManager';

/**
 * AvailabilityManagerHub - Wrapper for availability management
 * Provides a clean container for the WeeklyAvailabilityManager
 */
const AvailabilityManagerHub = () => {
  return (
    <div className="w-full">
      <WeeklyAvailabilityManager />
    </div>
  );
};

export default AvailabilityManagerHub;